module.exports = "/reports/components/chartComponent-ce6459.html";